import { render, staticRenderFns } from "./CorteEtario.vue?vue&type=template&id=624c6532&"
import script from "./CorteEtario.vue?vue&type=script&lang=js&"
export * from "./CorteEtario.vue?vue&type=script&lang=js&"
import style0 from "./CorteEtario.vue?vue&type=style&index=0&id=624c6532&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports